module.exports = __webpack_public_path__ + "static/fox-sprite-1e9a9a9a3eef7478e362c65d18f0cf34.png";